import Image from "next/image";
import Link from "next/link";
import { useAppContext } from "@/context/Context";
import React, { useEffect, useState } from "react";

import sal from "sal.js";

import boxedLogo from "../../public/images/logo/boxed-logo.png";
import google from "../../public/images/sign-up/google.png";
import facebook from "../../public/images/sign-up/facebook.png";
import PageHead from "@/pages/Head";
import auth from '@/context/firebaseconfig';
import { createUserWithEmailAndPassword, signInWithEmailAndPassword } from "firebase/auth";
import { useRouter } from "next/router";
import getFirebaseToken from "@/context/Auth";
import { getUserInfoApi } from "@/services/userApi";

import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const UserSignIn = () => {
  const { toggleAuth, setToggleAuth } = useAppContext();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [errorMessage, setErrorMessage] = useState('');

  const router = useRouter();

  useEffect(() => {
    sal();

    const cards = document.querySelectorAll(".bg-flashlight");

    cards.forEach((bgflashlight) => {
      bgflashlight.onmousemove = function (e) {
        let x = e.pageX - bgflashlight.offsetLeft;
        let y = e.pageY - bgflashlight.offsetTop;

        bgflashlight.style.setProperty("--x", x + "px");
        bgflashlight.style.setProperty("--y", y + "px");
      };
    });
  }, []);



  const handlesignIn = async (event) => {
    event.preventDefault();

    try {
      console.log('login...')
      const user = await signInWithEmailAndPassword(auth, email, password);
      console.log('user', user)
      if (user.error) {
        console.log("User Sign In error", user.error)
        toast.error("You have entered an invalid email or password.");
      } else {
        if (!user.user.emailVerified) {
          router.push('/VerifyEmail');
        } else {
          console.log('user', user)
          const response = await getUserInfoApi();
          if (response.status === 200) {
            const userData = response.data;
            console.log('userData', userData);
            router.push('/dashboard');
          } else {
            console.log("User Sign In error", response)
            toast.error("An error occurred during sign in.");
          }
        }
      }
    } catch (error) {
      console.log("User Sign In error", error)
      toast.error('An error occurred during sign in.');
    }
  };


  return (
    <>
      <PageHead title="Log In" />
      <ToastContainer position="top-right" autoClose={5000} />
      <div className="signup-area jureeltd-section-gapTop-big" data-black-overlay="2">
        <div className="sign-up-wrapper jureeltd-section-gap">
          <div className="sign-up-box bg-flashlight">
            {/* Removed the signup-box-top section */}
            <div className="separator-animated animated-true"></div>
            <div className="signup-box-bottom">
              <div className="signup-box-content">
                <h4 className="title">Welcome Back!</h4>
                {/* <div className="social-btn-grp">
                  <Link className="btn-default btn-border" href="#">
                    <span className="icon-left">
                      <Image src={google} width={18} height={18} alt="Google Icon" />
                    </span>
                    Login with Google
                  </Link>
                  <Link className="btn-default btn-border" href="#">
                    <span className="icon-left">
                      <Image src={facebook} width={18} height={18} alt="Google Icon" />
                    </span>
                    Login with Facebook
                  </Link>
                </div> */}
                {/* <div className="text-social-area">
                  <hr />
                  <span>Or continue with</span>
                  <hr />
                </div> */}

                <form onSubmit={handlesignIn} className="signup-form">
                  <div className="input-section mail-section">
                    <div className="icon">
                      <i className="feather-mail"></i>
                    </div>
                    <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="Enter your .ac.uk email address" />
                  </div>
                  <div className="input-section password-section">
                    <div className="icon">
                      <i className="feather-lock"></i>
                    </div>
                    <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="Password" />
                  </div>
                  <div className="forget-text">
                    <Link className="btn-read-more" href="Forget">
                      <span>Forgot password?</span>
                    </Link>
                  </div>
                  <button type="submit" className="btn-default">
                    Sign In
                  </button>
                </form>
     
              </div>
              <div className="signup-box-footer">
                <div className="bottom-text">
                  Don't have an account?
                  {/* <Link className="btn-read-more ps-2" href="#" onClick={() => setToggleAuth(!toggleAuth)}> */}

                  <Link className="btn-read-more ps-2" href="SignUp" >
                    {/* {toggleAuth ? <span>Sign Up</span> : <span>Sign In</span>} */}
                    <span >
                      Sign Up
                    </span>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default UserSignIn;
